<div class="counts" *ngIf="customerVisitCounts">
  <mat-expansion-panel class="count-panel" [hideToggle]="true">
    <mat-expansion-panel-header class="header">
      <mat-panel-title class="panel-title"
        >Customer Visits
        <span>{{ customerVisitCounts.total }}</span></mat-panel-title
      >
    </mat-expansion-panel-header>
    <div class="panel-body">
      <div
        class="panel-item"
        [routerLink]="[
          'counts/list',
          'customerVisitCounts',
          'customerVisitsNeedingDisposition'
        ]"
      >
        <p class="count">Customer Visits Needing Disposition</p>
        <span>{{ customerVisitCounts.customerVisitsNeedingDisposition }}</span>
      </div>
      <div
        *ngIf="
          getUserRole() !== 'Inside Sales' &&
          getUserRole() !== 'Inside Sales Manager'
        "
        class="panel-item"
        [routerLink]="[
          'counts/list',
          'customerVisitCounts',
          'pendingCustomerVisits'
        ]"
      >
        <p class="count">Pending Customer Visits</p>
        <span>{{ customerVisitCounts.pendingCustomerVisits }}</span>
      </div>
      <div
        *ngIf="
          getUserRole() === 'Inside Sales' ||
          getUserRole() === 'Inside Sales Manager' ||
          getUserRole() === 'Admin' ||
          getUserRole() === 'Super Admin'
        "
        class="panel-item"
        [routerLink]="[
          'counts/list',
          'customerVisitCounts',
          'availableForInsideSales'
        ]"
      >
        <p class="count">Available for Inside Sales</p>
        <span>{{ customerVisitCounts.availableForInsideSales }}</span>
      </div>
      <div
        *ngIf="
          getUserRole() === 'Inside Sales Manager' ||
          getUserRole() === 'Admin' ||
          getUserRole() === 'Super Admin'
        "
        class="panel-item"
        [routerLink]="[
          'counts/list',
          'customerVisitCounts',
          'pendingDeadAppointments'
        ]"
      >
        <p class="count">Pending Dead Appointments</p>
        <span>{{ customerVisitCounts.pendingDeadAppointments }}</span>
      </div>
      <div
        *ngIf="
          getUserRole() === 'Inside Sales Manager' ||
          getUserRole() === 'Admin' ||
          getUserRole() === 'Super Admin'
        "
        class="panel-item"
        [routerLink]="[
          'counts/list',
          'customerVisitCounts',
          'pendingChangeOrders'
        ]"
      >
        <p class="count">Pending Change Orders</p>
        <span>{{ customerVisitCounts.pendingChangeOrders }}</span>
      </div>
      <div
        *ngIf="getUserRole() === 'Estimator'"
        class="panel-item"
        [routerLink]="['counts/list', 'customerVisitCounts', 'hotQuotes']"
      >
        <p class="count">Hot Quotes</p>
        <span>{{ customerVisitCounts.hotQuotes }}</span>
      </div>
    </div>
  </mat-expansion-panel>
</div>
